import { CUSTOMER_INPUT_KEYS } from '../../../../services/exports/Constants';
import { ValidationErrorResponseData } from '../../../../services/exports/Types';

// Fields the customer fixes in the order-method modal, not in the checkout form.
const ORDER_METHOD_FIELDS = [
  'room_service_location_id',
  'on_site_table_id',
  'on_site_table_name',
  'delivery_quote_id',
  'delivery_street_name',
  'delivery_street_number',
  'delivery_city',
  'delivery_zip_code',
];

export interface CartValidationError {
  fields: string[];
  opensOrderMethod: boolean;
  /**
   * The redemption is the only thing wrong: the persisted points no longer fit the balance or
   * the program limits. Recoverable by dropping the points, not by anything the customer types.
   */
  rejectsOnlyCashbackPoints: boolean;
  /**
   * Every failing field is one the checkout form renders an inline error for — typically a
   * half-typed email persisted from an earlier session. The cart has no input for it, so the
   * customer has to be let through to the form instead of being stopped on an alert.
   */
  fixableInCheckout: boolean;
  message: string | null;
}

/**
 * Reads a 422 from /order-validations. Laravel sends `rules` and `errors` keyed by field,
 * so they are objects — the cart used to test `rules.length`, which is always undefined
 * on an object, and every 422 fell through to the generic "unexpected problem" alert.
 */
export function describeCartValidationError(data?: Partial<ValidationErrorResponseData>): CartValidationError {
  const fields = Object.keys(data?.rules ?? data?.errors ?? {});
  const firstFieldMessage = Object.values(data?.errors ?? {})[0]?.[0];

  return {
    fields,
    opensOrderMethod: fields.some((field) => ORDER_METHOD_FIELDS.includes(field)),
    rejectsOnlyCashbackPoints: fields.length === 1 && fields[0] === 'cashback_points',
    fixableInCheckout: fields.length > 0 && fields.every((field) => CUSTOMER_INPUT_KEYS.includes(field)),
    message: firstFieldMessage || data?.message || null,
  };
}
